import moment from "moment";
import "moment-timezone";

export const formatContainerNumbers = (raw: unknown): string => {
  if (!raw) return "";
  const values = Array.isArray(raw)
    ? raw
    : String(raw)
        .split(/[,\n]/g)
        .map((v) => v.trim())
        .filter(Boolean);

  return values
    .map((v: any) =>
      typeof v === "object" && v !== null
        ? String(v?.containerNo ?? v?.containerNumber ?? v?.name ?? "").trim()
        : String(v ?? "").trim()
    )
    .filter(Boolean)
    .join(", ");
};

export const columns = [
  {
    accessorKey: "actionButtons",
    header: "Action",
    size: 130,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
  {
    accessorKey: "vehicleNumber",
    header: "Vehicle",
    type: "string",
    size: 140,
  },
  {
    accessorKey: "gateEntryDate",
    header: "Entry",
    size: 130,
    type: "dateTime",
    accessorFn: function customCell(row: any) {
      return `${
        row.gateEntryDate ? moment(row.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A") : ""
      }`;
    },
  },
  {
    accessorKey: "consignmentType",
    header: "Consignment ",
    description: "This column has a value getter and is not sortable.",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "virNumber",
    header: "VIR No.",
    type: "string",
    size: 180,
  },
  {
    accessorKey: "containerNumbers",
    header: "Containers",
    type: "string",
    size: 180,
    accessorFn: (row: any) => formatContainerNumbers(row?.containerNumbers),
  },
  { accessorKey: "driverName", header: "Driver", size: 130 },
  {
    accessorKey: "vehicleType",
    header: "Type",
    type: "string",
    size: 120,
  },
  { accessorKey: "vehicleStatus", header: "Status", size: 130 },
  { accessorKey: "terminalLocation", header: "Location", size: 150 },
  {
    accessorKey: "gateOutDate",
    header: "Checkout",
    size: 150,
    type: "dateTime",
    accessorFn: function customCell(row: any) {
      return `${row.gateOutDate ? moment(row.gateOutDate).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
];
